import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import { FaBars, FaRegTimesCircle } from "react-icons/fa";
import menuLinks from "../../assets/data/menu-links";
import logo from "../../assets/images/logo.png";
import "./Header.sass";
const Header = () => {
	const [openMenu, setOpenMenu] = useState(false);

	const handleMenuToggle = () => {
		setOpenMenu(!openMenu);
	};

	return (
		<header className="headerSection bg--section mb-auto">
			<Container>
				<div className="headerWrapper">
					<div className="logo">
						<a href="/">
							<img src={logo} alt="logo" />
						</a>
					</div>
					<div className={`menuWrapper ${openMenu ? "active" : ""}`}>
						<div className="menuWrapperInner">
							<ul className="menu">
								{menuLinks.map(({ id, links, name }) => (
									<li key={id}>
										<a href={links} onClick={handleMenuToggle}>
											{name}
										</a>
									</li>
								))}
							</ul>
							<div className="menu-right">
								<select className="header-select">
									<option>English</option>
									<option>Bangla</option>
									<option>Hindi</option>
									<option>Urdu</option>
								</select>
								<a href="/" className="btn--base">
									<span>
										Join Community <BsArrowRight />
									</span>
								</a>
							</div>
							<div
								className="header-close-button d-lg-none"
								onClick={handleMenuToggle}
							>
								<FaRegTimesCircle />
							</div>
						</div>
					</div>
					<div className="menuToggle d-lg-none" onClick={handleMenuToggle}>
						<FaBars />
					</div>
				</div>
			</Container>
		</header>
	);
};

export default Header;
